import React from 'react';
import {
  Divider,
  Fade,
  Typography,
  useTheme,
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import uafLogo from '../../../assets/uaf.svg';
import getPartnerButton from '../../../components/PartnerButtons';
import TermsAndConditionsLink from '../../../components/TermsAndConditionsLink';
import { Partner } from '../../../components/LeadFormIndex/types';
import analytics, { resetAnalytics } from '../../../utils/analytics';
import HTMLParser from '../../../components/HTMLParser';

type PLRWelcomeProps = {
  amount: string,
  periods: string,
  handleSetShowForm: (show:boolean)=> void,
  origin: string,
  partner: Partner,
}

export default function PLRWelcome(props:PLRWelcomeProps) {
  const {
    amount, periods, handleSetShowForm, origin, partner,
  } = props;
  const theme = useTheme();
  const [checked, setChecked] = React.useState(false);
  const [logo, setLogo] = React.useState<string | null>(null);
  const [footerLogo, setFooterLogo] = React.useState<string | undefined>(undefined);
  const [loading, setLoading] = React.useState(false);
  const handleSetChecked = () => setChecked((o) => !o);

  React.useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setLogo(partner.config.styles?.headerLogo || null);
      setFooterLogo(partner.config.styles?.footerLogo);
      setLoading(false);
    };
    fetchData();
  }, [partner.config]);
  React.useEffect(() => {
    resetAnalytics();
    analytics.page('PLR - ONBOARDING', 'BIENVENIDA');
  }, []);

  return (
    <Fade
      in
    >
      <div style={{
        backgroundColor: theme.palette.background.default,
        height: '100%',
        display: 'grid',
        alignItems: 'center',
      }}
      >
        <div>
          {loading || !logo ? <div style={{ width: '300px', height: '80px', margin: 'auto' }} />
            : (
              <div style={{ width: '300px', height: '80px', margin: 'auto' }}>
                <object
                  data={logo}
                  aria-labelledby="Bancame Logo"
                  style={{
                    width: '100%',
                    height: '100%',
                  }}
                />
              </div>
            )}
          <Typography
            data-pw="preloan-welcome-header"
            variant="h3"
            fontWeight="light"
            style={{ marginInline: 'auto', marginBlock: '1%' }}
            component="div"
          >
            {partner.config.preLoanRequestConfig?.welcomeText?.header && (
            <HTMLParser
              html={partner.config.preLoanRequestConfig?.welcomeText?.header}
            />
            )}
          </Typography>

          <br />
          <div style={{ maxWidth: 800 }}>
            <Divider />
            <Typography
              variant="body1"
              data-pw="preloan-welcome-text"
              component="div"
              style={{
                padding: '3%',
                lineHeight: '1.8',
                backgroundColor: partner.config.styles?.backgroundSecondaryColor
                  || theme.palette.background.defaultSecondary,
              }}
            >
              {amount
                ? (
                  <>
                    ¡Hola!
                    {' '}
                    Estás a punto de comenzar la
                    {' '}
                    <b style={{ color: theme.palette.text.primary }}>
                      solicitud de un crédito
                      responsable de
                      {` $${(+amount).toLocaleString('es-CL')}`}
                    </b>
                    {periods
                      ? (
                        <>
                          , en un plazo de
                          {` ${(+periods)} meses. `}
                        </>
                      ) : '. '}
                    <b style={{ color: theme.palette.text.primary }}>
                      tu RUT,
                      tu última liquidación de sueldo y finalmente tu ClaveÚnica,
                      o tus últimas 12 cotizaciones de AFP.
                    </b>
                  </>
                ) : (
                  // eslint-disable-next-line react/jsx-no-useless-fragment
                  <>
                    {partner.config.preLoanRequestConfig?.welcomeText?.firstMessage && (
                    <HTMLParser
                      html={partner.config.preLoanRequestConfig?.welcomeText?.firstMessage}
                    />
                    )}
                  </>
                )}
            </Typography>
            <Divider />
            <br />
            <TermsAndConditionsLink
              origin={origin}
              checked={checked}
              handleSetChecked={handleSetChecked}
              partner={partner}
              formControlLabelProps={{
                backgroundColor: theme.palette.background.defaultSecondary,
                padding: '10px',
                borderRadius: 20,
                margin: '0px 20px',
              }}
            />
          </div>
          <Typography
            variant="body2"
            style={{ padding: '2.5%', maxWidth: 500, margin: 'auto' }}
          >

            Por favor acepta los términos y condiciones, la política de privacidad y haz click en
            {' '}
            <span style={{ fontWeight: 'bold' }}>Comenzar</span>
            {' '}
            para continuar
          </Typography>
          {getPartnerButton({
            partner,
            disabled: !checked,
            onClick: () => handleSetShowForm(true),
            buttonLabel: 'Comenzar',
            endIcon: <ArrowForwardIcon style={{
              color: partner.config.styles?.secondaryColor === theme.palette.secondary.main
                ? theme.palette.white.main
                : partner.config.styles?.primaryColor,
            }}
            />,
            testingLabel: 'preloan-welcome-button',
          })}
          {footerLogo && (
          <Typography
            variant="body1"
            style={{
              margin: '15px', display: 'flex', placeContent: 'center', color: 'gray',
            }}
            fontStyle="italic"
          >
            {'Alianza con '}
            {loading ? <span>Cargando...</span>
              : (
                <object
                  style={{ marginLeft: 5 }}
                  data={footerLogo}
                  width="80px"
                  height="22px"
                  aria-labelledby="Provider Logo"
                />
              )}
          </Typography>
          ) }
          <Typography
            variant="body2"
            fontStyle="italic"
            style={{
              padding: '2.5%',
              marginLeft: '1em',
              marginRight: '1em',
            }}
          >

            Estamos regulados por la
            <a href="https://www.uaf.cl">
              <object
                style={{ marginLeft: 5, marginTop: '10%' }}
                data={uafLogo}
                width="100px"
                aria-labelledby="Provider Logo"
              />
            </a>
          </Typography>
        </div>
      </div>
    </Fade>
  );
}
